/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    AppellationDetailsDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class AppellationControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        getAll(
    ): Observable<Array<AppellationDetailsDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/appellation`;

            return this._httpClient.get<Array<AppellationDetailsDto>>(url, requestOptions);
    }


}

